import { render, staticRenderFns } from "./PopularProducerAndTracks.vue?vue&type=template&id=2ee76339&scoped=true&"
import script from "./PopularProducerAndTracks.vue?vue&type=script&lang=js&"
export * from "./PopularProducerAndTracks.vue?vue&type=script&lang=js&"
import style0 from "./PopularProducerAndTracks.vue?vue&type=style&index=0&id=2ee76339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee76339",
  null
  
)

export default component.exports